export const DEFAULT_IMAGE_URL = "https://superswap.ink/media/unknown.svg"

export const NATIVE_GAS_FEE = 1000000000000000n

export const SWAP_FEE = 0n

export const FEE_RECEIVER = "0xec288809063df839a62a3a61dd28f2142592b170"
